module.exports = __webpack_public_path__ + "static/media/karajan-akademie-logo.cf2dd69c.png";